import { Typography } from "@mui/material";
import { FontDownload as FontDownloadIcon } from "@mui/icons-material"
import FormBuilderDesign from "components/InputsDesign/FormBuilderDesign";
import { DataFields } from "./DataFields";

export default function FontSizeModule({ 
  t,
  dataInstance, 
  register, 
  errors, 
  changeDataFunction
}) {

  return (<>
    <Typography variant="h6" sx={{ display: "flex", alignItems: "center" }}><FontDownloadIcon /> &nbsp; {t('designmenu_select_option_typography')}</Typography>
    <FormBuilderDesign 
      dataDields={DataFields(t)}
      dataInstance={dataInstance}
      register={register}
      errors={errors}
      changeDataFunction={changeDataFunction}
    />
  </>)
}